{
  "upgrade_modal": {
    "title": "Actualiza tu plan",
    "title_meeting_minutes": "Se agotaron tus minutos de reunión este mes",
    "title_limit_reached": "Llegaste al límite de tu plan",
    "title_feature_locked": "Desbloquea más con un plan superior",
    "limit_reason": "Llegaste al límite de tu plan actual ({plan}).",
    "feature_reason": "Esta función está disponible en un plan superior.",
    "limit_detail": {
      "members": "Estás en el tope de {limit} miembros.",
      "active_tasks": "Estás en el tope de {limit} tareas activas.",
      "storage_bytes": "Estás en el tope de almacenamiento.",
      "meeting_minutes_monthly": "Usaste todos los minutos de reuniones AI de este mes."
    },
    "current_plan_label": "Plan actual",
    "trial_label": "trial",
    "meeting_options_intro": "Tienes dos opciones:",
    "meeting_option_pack": "Compra un pack",
    "meeting_option_pack_detail": "de minutos extra desde $1 — no expiran.",
    "meeting_option_business": "Sube a Business",
    "meeting_option_business_detail": "para obtener 50h/mes incluidas.",
    "pro_pitch_lead": "Con",
    "pro_pitch_body": "obtienes miembros, tareas y almacenamiento sin tope, timeline, custom fields, plantillas y más.",
    "cta_view_plans": "Ver planes",
    "cta_close": "Cerrar",
    "cta_later": "Más tarde",
    "cta_buy_pack": "Comprar pack",
    "generic_message": "Tu plan actual no permite esta acción."
  },
  "page": {
    "title": "Planes y facturación",
    "subtitle": "Elige el plan que se adapta a tu equipo. Cambia cuando quieras.",
    "on_trial": "Estás en trial Pro — {n} días restantes",
    "cycle_monthly": "Mensual",
    "cycle_yearly": "Anual",
    "yearly_discount": "−16%",
    "loading_plans": "Cargando planes…",
    "subscription_trialing": "Suscripción en trial",
    "subscription_active": "Suscripción activa",
    "ends_on": "Termina el {date}",
    "manage_subtitle": "Gestiona método de pago, facturas y cancelación desde el portal de Stripe",
    "opening": "Abriendo…",
    "manage": "Gestionar",
    "most_popular": "Más popular",
    "current_label": "Actual",
    "per_workspace_month": "/ workspace / mes",
    "per_workspace_year": "/ workspace / mes, pago anual",
    "seats_included": "Incluye {n} asientos · ${price} por asiento extra / {cycle}",
    "team_estimate": "Tu equipo ({members} miembros, {extra} extra): ${total} / {cycle}",
    "cycle_unit_month": "mes",
    "cycle_unit_year": "año",
    "billed_yearly": "facturado ${price}/año",
    "forever": "Para siempre",
    "owner_only_upgrade": "Solo el dueño del equipo puede actualizar",
    "cta_current_plan": "Tu plan actual",
    "cta_start_free": "Comenzar gratis",
    "cta_redirecting": "Redirigiendo…",
    "cta_upgrade": "Actualizar",
    "cta_switch": "Cambiar a este plan",
    "cta_switching": "Cambiando…",
    "switch_confirm_title": "¿Cambiar a {plan}?",
    "switch_confirm_message": "El cambio se aplica de inmediato. Cobramos o abonamos la diferencia del periodo en curso en tu tarjeta registrada.",
    "switch_confirm_cta": "Cambiar de plan",
    "msg_plan_switched": "¡Plan actualizado! Tus nuevas funciones ya están disponibles.",
    "members_unit": "miembros",
    "members_unlimited": "Miembros ilimitados",
    "active_tasks_unit": "tareas activas",
    "active_tasks_unlimited": "Tareas activas ilimitadas",
    "storage_suffix": "de almacenamiento",
    "storage_unlimited": "Almacenamiento ilimitado",
    "meeting_duration_cap": "hasta {n} min por reunión",
    "minutes_unlimited": "Minutos AI ilimitados",
    "minutes_with_hours": "{value} min ({hrs}h) de transcripción AI/mes",
    "minutes_only": "{value} min de transcripción AI/mes",
    "unlimited": "Ilimitado",
    "unlimited_lower": "ilimitado",
    "free": "Gratis",
    "packs": {
      "label": "Minutos extra",
      "title": "¿Te quedaste corto este mes?",
      "subtitle": "Compra minutos extra de reuniones AI. No expiran, se acumulan con tu cuota mensual.",
      "bonus_available": "Tienes {minutes} extra disponibles",
      "most_popular": "Más popular",
      "minutes_hours": "{minutes} min ({hours} horas)",
      "never_expire": "No expiran nunca",
      "per_hour": "{price}/hora",
      "buy": "Comprar",
      "owner_only_buy": "Solo el dueño del equipo puede comprar minutos extra."
    },
    "footer": "Pagos procesados de forma segura por Stripe. Cancelas cuando quieras.",
    "msg_subscription_activated": "¡Suscripción activada! Puede tardar unos segundos en sincronizarse.",
    "msg_canceled": "Proceso cancelado. Puedes intentarlo de nuevo cuando quieras.",
    "msg_pack_purchased": "¡Pack de minutos comprado! Se acreditarán en segundos.",
    "msg_pack_canceled": "Compra del pack cancelada.",
    "error_owner_only_pack": "Solo el dueño del equipo puede comprar minutos.",
    "error_pack_purchase": "No se pudo iniciar la compra del pack.",
    "error_owner_only_billing": "Solo el dueño del equipo puede gestionar la facturación.",
    "error_checkout": "No se pudo iniciar el checkout. Verifica que Stripe esté configurado en el servidor.",
    "error_portal": "No se pudo abrir el portal de facturación.",
    "cta_downgrade_free": "Bajar a Free",
    "usage": {
      "title": "Tu uso actual",
      "subtitle": "Plan {plan}",
      "members": "Miembros",
      "active_tasks": "Tareas activas",
      "storage": "Almacenamiento",
      "minutes": "Minutos IA este mes",
      "no_limit": "{used} · sin límite"
    }
  },
  "features": {
    "ai_meetings": "🎙️ Reuniones con IA — transcripción + tareas auto",
    "ai_summary": "✨ Resúmenes ejecutivos con IA",
    "ai_triage": "✨ Triage AI (texto → tarea estructurada)",
    "time_tracking": "Time tracking",
    "kanban": "Vista Kanban",
    "list_view": "Vista de lista",
    "my_tasks": "Vista Mis tareas",
    "timeline": "Timeline / Gantt",
    "calendar": "Calendario",
    "subtasks": "Subtareas",
    "comments": "Comentarios",
    "realtime_chat": "Chat en tiempo real",
    "attachments": "Adjuntos",
    "tags": "Tags",
    "in_app_notifications": "Notificaciones in-app",
    "email_notifications": "Notificaciones por email",
    "custom_fields": "Campos personalizados",
    "templates": "Plantillas de proyectos",
    "automation_rules": "Reglas de automatización",
    "forms": "Formularios públicos",
    "dashboards": "Dashboards",
    "export_csv": "Exportar a CSV",
    "activity_log_full": "Historial completo",
    "portfolios": "Portafolios",
    "goals": "Objetivos / OKRs",
    "workload": "Capacidad del equipo",
    "approvals": "Aprobaciones",
    "external_guests": "Invitados externos",
    "sso": "SSO (SAML)",
    "api_public": "API pública",
    "webhooks": "Webhooks",
    "priority_support": "Soporte prioritario"
  }
}
